import { render, staticRenderFns } from "./TripItineraryItems.vue?vue&type=template&id=6bb468f9&"
import script from "./TripItineraryItems.vue?vue&type=script&lang=js&"
export * from "./TripItineraryItems.vue?vue&type=script&lang=js&"
import style0 from "./TripItineraryItems.vue?vue&type=style&index=0&id=6bb468f9&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb468f9')) {
      api.createRecord('6bb468f9', component.options)
    } else {
      api.reload('6bb468f9', component.options)
    }
    module.hot.accept("./TripItineraryItems.vue?vue&type=template&id=6bb468f9&", function () {
      api.rerender('6bb468f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/TripItineraryItems.vue"
export default component.exports